<script>
import ADuiTabOptions from '@dui/components/a-dui-tab-options/a-dui-tab-options.vue';
import TAB_OPTION_ILLUSTRATED_IMG from '@dui-assets/tab-option-illustrated.svg';
import TAB_OPTION_TEXT_IMG from '@dui-assets/tab-option-text.svg';

const BOOK_TYPE_OPTIONS = [
  {
    description: 'Standard fiction / non-fiction books. Can contain small illustrations.',
    image: TAB_OPTION_TEXT_IMG,
    title: 'Trade paperback / ebook',
    topOverride: '38px',
    value: 'default',
  },
  {
    description: `E.g: Children's picture books or cookbooks.`,
    image: TAB_OPTION_ILLUSTRATED_IMG,
    title: 'Illustrated book',
    topOverride: null,
    value: 'illustrated',
  },
];

export default {
  extends: ADuiTabOptions,
  data: () => ({
    vm: {
      options: BOOK_TYPE_OPTIONS,
    },
  }),
};
</script>
